import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_spread_props } from "@swc/helpers/_/_object_spread_props";
import { useMemo } from 'react';
import { useGTMDispatch } from '@elgorditosalsero/react-gtm-hook';
import { ignoreError } from '~/infra/utils';
export const useGtm = ()=>{
    const sendDataToGTM = useGTMDispatch();
    return useMemo(()=>({
            sendEventDeprecated (eventName, eventData) {
                ignoreError(()=>{
                    sendDataToGTM({
                        event_data: null
                    }); //clear previous event_data
                    sendDataToGTM({
                        event: eventName,
                        event_data: eventData
                    });
                });
            },
            report (eventType, label, data) {
                ignoreError(()=>{
                    const eventNameWithProperties = getEventNameWithProperties(eventType, label);
                    const eventDataWithProperties = getEventDataWithProperties(eventType, label, data);
                    sendDataToGTM({
                        event_data: null
                    }); //clear previous event_data
                    sendDataToGTM({
                        event: eventNameWithProperties,
                        event_data: eventDataWithProperties
                    });
                });
            },
            sendEvent (eventName, eventData) {
                ignoreError(()=>{
                    sendDataToGTM(_object_spread({
                        event: eventName
                    }, eventData));
                });
            },
            sendPageView (eventData) {
                ignoreError(()=>{
                    sendDataToGTM(_object_spread({
                        event: 'page_view'
                    }, eventData));
                });
            }
        }), []);
};
const getEventNameWithProperties = (eventType, label)=>"".concat(eventType, "-").concat(label);
const getEventDataWithProperties = (eventType, label, data)=>{
    const [category, action] = eventType.split('-');
    const eventDataWithProperties = _object_spread_props(_object_spread({}, data), {
        event_category: category,
        event_action: action,
        event_label: label
    });
    return eventDataWithProperties;
};
